import { TabMenuItemProps } from "@/components/TabMenuItem";
import { Icons, Urls } from "@/util";

const createSeasonMenu = (code: string, page: string): TabMenuItemProps[] => {
    const url = (tab?: string) => Urls.season(code, tab)
    const tab = (key: string, path: string, caption: string, shortCaption: string, icon: string) => ({ 'active': page == key, url: url(path), caption, icon, shortCaption })

    return [
        tab('overview', '', 'Overzicht', 'Ovz', Icons.season),
        tab('episodes', 'afleveringen', 'Afleveringen', 'Afl', Icons.episode),
        tab('participants', 'deelnemers', 'Deelnemers', 'Dln', Icons.participant),
        tab('games', 'opdrachten', 'Opdrachten', 'Opd', Icons.game),
        tab('map', 'kaart', 'Kaart', 'Krt', Icons.map),
        tab('money', 'geld', 'Geld', 'Gld', Icons.money),
        tab('more', 'meer', 'Meer', 'Meer', Icons.more),
        //tab('schedule', 'planning', 'Planning', 'Pln', Icons.schedule),
        //tab('suspicions', 'verdenkingen', 'Verdenkingen', 'Vrd', Icons.suspicions),
        //tab('viewers', 'kijkcijfers', 'Kijkcijfers', 'Kcf', Icons.viewers)
    ];
};

export default createSeasonMenu